import { motion, useInView } from "framer-motion";
import { useRef } from "react";

const AnimatedBlock = ({ children, delay = 0 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-60px" });
  return (
    <motion.div
      ref={ref}
      initial={{ opacity: 0, y: 30 }}
      animate={isInView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 0.8, delay, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
};

const IntroSection = () => {
  return (
    <section
      data-testid="intro-section"
      id="intro-section"
      className="py-24 md:py-32 bg-[#F5F0EB]"
    >
      <div className="max-w-4xl mx-auto px-6 lg:px-12">
        {/* Featured photo - archi con mare */}
        <AnimatedBlock>
          <div className="mb-16 max-w-3xl mx-auto">
            <div className="rounded-[2rem] overflow-hidden shadow-[0_20px_60px_rgba(68,47,35,0.08)]">
              <img
                src="https://customer-assets.emergentagent.com/job_inner-light-path-2/artifacts/necw81og_bbb.jpg"
                alt="Alessia Stella - Light Workers House"
                className="w-full h-auto object-cover"
                data-testid="intro-featured-photo"
              />
            </div>
          </div>
        </AnimatedBlock>

        <div className="text-center">
        <AnimatedBlock>
          <p className="text-sm uppercase tracking-[0.2em] text-[#AC8E60] font-body font-semibold mb-4 text-lg md:text-xl">
            Light Workers House - La casa dei Guerrieri di Luce
          </p>
        </AnimatedBlock>

        <AnimatedBlock delay={0.1}>
          <p className="font-body text-base md:text-lg text-[#442F23]/80 leading-relaxed mb-6">
            Sei in cammino da un po' di tempo ma <strong>qualcosa di grande dentro di te ti sta chiamando</strong> e non puoi pi&ugrave; ignorarlo.
          </p>
        </AnimatedBlock>

        <AnimatedBlock delay={0.2}>
          <p className="font-body text-base md:text-lg text-[#442F23]/80 leading-relaxed mb-6">
            &Egrave; la tua luce interiore, <strong>la tua essenza</strong>, che ti chiede di uscire, di essere mostrata e non pi&ugrave; rimpicciolita dal tuo sabotatore interiore.
          </p>
        </AnimatedBlock>

        <AnimatedBlock delay={0.3}>
          <p className="font-body text-base md:text-lg text-[#442F23]/80 leading-relaxed mb-6">
            <strong>Light Workers House</strong> &egrave; uno spazio di gruppo spiritualmente concreto per la persona pronta a lasciare andare i blocchi, le maschere e le vecchie identit&agrave; limitanti che non le appartengono pi&ugrave;.
          </p>
        </AnimatedBlock>

        <AnimatedBlock delay={0.4}>
          <p className="font-body text-base md:text-lg text-[#442F23]/75 leading-relaxed mb-8">
            &Egrave; uno <strong>spazio intenzionale pratico</strong>, dove camminerai accompagnata/o esclusivamente da altre anime in risveglio come te, altri guerrieri di luce pronti a portare la loro luce nel mondo attraverso pratiche energetiche, meditazioni, pratiche danzate, rituali, lavoro somatico, embodiment, regolazione ed espansione del sistema nervoso e molto altro.
          </p>
        </AnimatedBlock>

        <AnimatedBlock delay={0.5}>
          <p className="font-accent text-3xl md:text-5xl text-[#E1C340] font-bold" style={{ textShadow: "0 0 30px rgba(225,195,64,0.3)" }}>
            La tua essenza ti sta chiamando....
          </p>
        </AnimatedBlock>

        <AnimatedBlock delay={0.6}>
          <div className="mt-12 max-w-3xl mx-auto">
            <div className="rounded-[2rem] overflow-hidden shadow-[0_20px_60px_rgba(68,47,35,0.1)]">
              <img
                src="https://customer-assets.emergentagent.com/job_inner-light-path-2/artifacts/19fiqtm8_Minimalist%20Fashion%20Presentation%20Template%281%29.jpg"
                alt="Alessia Stella - Light Workers House"
                className="w-full h-auto object-cover"
                data-testid="intro-lwh-photo"
              />
            </div>
          </div>
        </AnimatedBlock>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;
